$(document).ready(function () {
	animationLoader();
	setBackgroundElement();
	// header
	mappingMenu();
	// swiper
	header.init();
	header.search();
	swiperInit();
	// infoWindow();
	clickViewMore();
	clicMoreTable();
	Fancybox.bind("[data-fancybox]", {
		placeFocusBack: false,
	});
	checkHoverTienIch();
	if ($(window).width() < 1200) {
		checkClickFieldActivy();
	}
	//
	recruitmentDetail();
	showContent();
	jsScrollSlide();
	AOS.init({
		// Global settings:
		disable: "mobile", // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
		offset: $("header").outerHeight(), // offset (in px) from the original trigger point
		delay: 150, // values from 0 to 3000, with step 50ms
		duration: 900, // values from 0 to 3000, with step 50ms
		easing: "ease", // default easing for AOS animations
	});
	expandItem();
	AOS.refresh();
	$(window).scroll(function () {
		AOS.refreshHard();
	});
});

function checkClickFieldActivy() {
	let count = 0;
	$(".home-3 .item-lvhd .img-lvhd a").click(function (e) {
		const checkType = e.pointerType;
		let dataCountRef = $(this).closest(".item-lvhd").attr("data-count");
		if (typeof dataCountRef === "undefined" || dataCountRef == 0) {
			$(this)
				.closest(".item-lvhd")
				.attr("data-count", 1)
				.siblings()
				.attr("data-count", 0);
			return false;
		} else {
			return true;
		}
	});
}
function clicMoreTable() {
	const $parent = $(".page-recruit-main.section-2"),
		$items = $parent.find("tr"),
		$button = $parent.find(".btn-view-more"),
		numItems = 10,
		maxItems = 5;
	$items.each(function (index) {
		if (index > numItems) {
			$(this).hide();
		}
	});
	if ($parent.find("tr:hidden").length <= 0) $button.hide();
	$button.click(function () {
		$parent.find("tr:hidden").each(function (index) {
			if (index < maxItems) {
				$(this).fadeToggle(600);
			}
		});
		if ($parent.find("tr:hidden").length === 0) {
			$button.hide();
		}
	});
}
/*==================== Click show product ====================*/
function clickViewMore() {
	var $parent = $(".toggle-list-show"),
		$items = $(".item-toggle-main"),
		$loadMoreButton = $(".toggle-list-show .btn-show-item"),
		$loadAllButton = $(".toggle-list-show .btn-view-all"),
		numberItems = $(".toggle-list-show").attr("data-number-item"), // số lượng item ban đầu hiển thị
		maxItems = $(".toggle-list-show").attr("data-number-max"); // Số lượng item mỗi lần nhấn
	var hiddenClass = "visually-hidden";
	$parent.each(function (number, item) {
		$(this)
			.find($items)
			.each(function (number, item) {
				if (number > numberItems - 1) {
					$(this).addClass(hiddenClass);
				}
			});
		if ($(this).find(`.${hiddenClass}`).length === 0) {
			$(this).find($loadMoreButton).hide();
			$(this).find($loadAllButton).hide();
		}
	});
	$loadAllButton.click(function () {
		$(this)
			.closest($parent)
			.find(`.${hiddenClass}`)
			.slideDown()
			.removeClass(`${hiddenClass}`);
		$(this).closest($parent).find(`.btn-view-more`).hide();
	});
	$loadMoreButton.click(function () {
		console.log(
			$(this).closest(".toggle-list-show").find(`.${hiddenClass}`).length
		);
		$(this)
			.closest(".toggle-list-show")
			.find(`.${hiddenClass}`)
			.each(function (number, index) {
				if (number < maxItems) {
					$(this).slideDown();
					$(this).removeClass(hiddenClass);
				}
			});
		if (
			$(this).closest(".toggle-list-show").find(`.${hiddenClass}`)
				.length === 0
		) {
			$(this).hide();
			$(this).closest(".toggle-list-show").find(".btn-view-all").hide();
		}
	});
}
/*==================== checkHoverTienIch ====================*/
function checkHoverTienIch(e) {
	// On load
	$(".home-3 .item-lvhd").eq(1).addClass("big");
	$(".home-3 .item-lvhd").mouseover(function () {
		$(this).addClass("big").siblings().removeClass("big");
	});
}
/*====================  ====================*/
function infoWindow() {
	$("main").append(
		'<div class="wrapInfoWidth" style="position:fixed;bottom:0;right:0;z-index: 999;display: flex;background-color: red;padding: 20px;gap: 20px;"><div class="infoWindowWidht"></div><div class="infoWindowHeight"></div></div>'
	);
	$(".infoWindowWidht").text($(window).width());
	$(".infoWindowHeight").text($(window).height());
}
let HomeFullPage = {
	playVideo: function () {
		$(".play-button").click(function () {
			let attrVideo = $("#video-player").attr("src");
			if (attrVideo) {
				$(this).fadeOut();
				$(".home-2 .img").fadeOut();
				$(".home-2 .video video").get(0).play();
			}
		});
		$(".video").click(function () {
			$(".home-2 .img").fadeIn();
			$(".home-2 .play-button").fadeIn();
			$(".home-2 .video video").get(0).pause();
		});
	},
	init: function () {
		// HomeFullPage.playVideo();
	},
};
/*==================== Play Video ====================*/
function setBackgroundElement() {
	$("[setBackground]").each(function () {
		var background = $(this).attr("setBackground");
		let backgroundMobile = $(this).attr("setBackgroundMobile");
		// console.log(backgroundMobile);
		if (
			typeof backgroundMobile !== "undefined" &&
			backgroundMobile !== false &&
			$(window).width <= 768
		) {
			$(this).css({
				"background-size": "100% auto",
				"background-position": "top left",
				"background-image": "url(" + backgroundMobile + ")",
			});
		} else {
			$(this).css({
				"background-size": "cover",
				"background-position": "center center",
				"background-image": "url(" + background + ")",
			});
		}
		//
	});
}
/*==================== Mapping Menu ====================*/
function mappingMenu() {
	let ww = $(window).width();
	if (ww < 1024) {
		$(".header-main-menu .list-menu-main").appendTo(".menu-mobile-main");
	}
	$(".section-product-about").appendTo(".page-about-main.section-6");
	$(".select-sort").appendTo(".wrap-tab-list-select");
	$(".get-img-search").appendTo(".search-form-main .img");
	$(".searchbox .wrap-form-subscribe").appendTo(".banner-text-form");
}
/*==================== Animation loader  ====================*/
function animationLoader(e) {
	$("body").addClass("loaded");
}
/*==================== Append Click Scroll Tab ====================*/
function clickScrollTab() {
	$(".wrap-tab-link ul").scrollTo("li.active", 800);
	let numberTab = $(".tabslet-tab li").length;
	let countNumber = 1;
	if (numberTab > 2) {
		$(".tabslet-tab").wrap('<div class="number-tab-wrap"></div>');
		$(".number-tab-wrap").append(
			'<div class="icon-next"><div class="next"><em class="material-icons">navigate_next</em></div></div>'
		);
		$(".icon-next").click(function () {
			if (countNumber < numberTab - 1) {
				$(this)
					.parent()
					.find(".tabslet-tab")
					.scrollTo("li:eq(" + countNumber + ")", 800);
				countNumber++;
			} else {
				countNumber = 1;
				$(this).parent().find(".tabslet-tab").scrollTo("li:eq(0)", 800);
			}
		});
	}
}
/*==================== JS Other ====================*/
function height(el) {
	var height = 0;
	$(el).each(function () {
		var thisHeight = $(this).height();
		if (thisHeight > height) {
			height = thisHeight;
		}
		setTimeout(() => {
			$(el).height(height);
		}, 100);
	});
}
let header = {
	breadCrumb: function () {
		if ($(".recruitment-detail-page").length) return;
		if ($(".news-detail-page2").length) return;
		$(".global-breadcrumb .breadcrumb").appendTo(".banner-breadcrumb");
	},
	scrollActive: function () {
		if ($(".project-tab-zone").length) return;
		let height = $("header").outerHeight();
		if ($(window).scrollTop() > height) {
			$("header").addClass("active");
		} else {
			$("header").removeClass("active");
		}
	},
	headerPadding: function () {
		let Heightheader = $("header").outerHeight();
		if ($(window).width() > 1200 && !$(".productpage").length) {
			$(".project-tab-zone").sticky({
				topSpacing: Heightheader,
				zIndex: 999,
			});
		}
	},
	checkActive: function () {
		let active = $(".nav-mobile nav ul li.dropdown").hasClass("active");
		$(".nav-mobile nav ul li.dropdown").each(function () {
			if ($(this).hasClass("active")) {
				$(this).addClass("toggle-dropdown");
				$(this).find(".dropdown-menu").slideDown();
			}
		});
	},
	init: function () {
		header.breadCrumb();
		header.hamburger();
		header.MenuDropdown();
		header.headerPadding();
		header.checkActive();
	},
	hamburger: function () {
		$("#burger").click(function () {
			$(this).toggleClass("active");
			$(".nav-mobile").toggleClass("active");
			$(".search").removeClass("active");
			$(".wrap-search-main").removeClass("active");
			$(".wrap-search-main").css("transform", "translateY(0px)");
			// $(".main-menu-fullscreen").toggleClass("isShow");
		});
	},
	MenuDropdown: function () {
		if ($(window).width() >= 1280) {
			$(".nav-mobile li.dropdown").hover(
				function () {
					$(this)
						.find(".dropdown-menu")
						.stop()
						.slideDown()
						.closest($(this))
						.siblings()
						.find(".dropdown-menu")
						.slideUp();
					$(this).addClass("toggle-dropdown");
				},
				function () {
					$(".nav-mobile .dropdown-menu").stop().slideUp();
					$(this).removeClass("toggle-dropdown");
				}
			);
		} else {
			var $main = $(".nav-mobile");
			$main.find("li.dropdown").click(function () {
				$(this).find(".dropdown-menu").slideToggle();
				$(this).toggleClass(".toggle-dropdown");
			});
		}
	},
	search: function () {
		$(".search").on("click", function () {
			let height = $("header").outerHeight();
			$("header").removeClass("active");
			$("#burger").removeClass("active");
			$(".nav-mobile").removeClass("active");
			if ($(this).hasClass("active")) {
				$(".wrap-search-main").css("transform", "translateY(0px)");
			} else {
				$(".wrap-search-main").css(
					"transform",
					"translateY(" + height + "px)"
				);
			}
			$(this).toggleClass("active");
			$(".wrap-search-main").toggleClass("active");
			setTimeout(() => {
				$("#ctl00_mdl141_ctl00_Search_txtSearch").focus();
			}, 100);
		});
	},
};
/*==================== Swiper ====================*/
function swiperInit() {
	var bannerHome = new Swiper(".home-1 .swiper", {
		slidesPerView: 1,
		// loop: true,
		effect: "fade",
		autoplay: {
			delay: 3000,
		},
	});
	$(".page-about-personnel .tabslet-content").each(function (index) {
		let name = `index-slide-${index}`;
		$(this).addClass(name);
		new Swiper(`.page-about-personnel .${name}  .swiper`, {
			observer: true,
			observeParents: true,
			slidesPerView: 1,
			autoplay: {
				delay: 3000,
			},
			spaceBetween: 30,
			watchSlidesProgress: true,
			loop: true,
			navigation: {
				nextEl: `.page-about-personnel .${name}  .btn-next`,
				prevEl: `.page-about-personnel .${name}  .btn-prev`,
			},
			breakpoints: {
				768: {
					spaceBetween: 30,
					slidesPerView: "auto",
				},
				1024: {
					spaceBetween: 30,
					slidesPerView: "auto",
				},
				1280: {
					spaceBetween: 60,
					slidesPerView: "auto",
				},
			},
		});
	});
	var home_4 = new Swiper(".home-4 .swiper", {
		grabCursor: true,
		// autoplay: {
		// 	delay: 3000,
		// },
		navigation: {
			prevEl: ".home-4 .swiper-button-prev",
			nextEl: ".home-4 .swiper-button-next",
		},
		breakpoints: {
			1280: {
				spaceBetween: 0,
				slidesPerView: 3,
				grid: {
					rows: "2",
				},
			},
			576: {
				spaceBetween: 16,
				slidesPerView: 2,
			},
			320: {
				spaceBetween: 12,
				slidesPerView: 1.2,
			},
		},
	});
	var home_6_thumb = new Swiper(".home-6 .thumb .swiper", {
		spaceBetween: 10,
		slidesPerView: 2,
		freeMode: true,
		// autoplay: {
		// 	delay: 3000,
		// },
		watchSlidesProgress: true,
		grabCursor: true,
		breakpoints: {
			1280: {
				slidesPerView: 3,
				spaceBetween: 16,
				direction: "vertical",
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 10,
				direction: "vertical",
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 8,
				direction: "vertical",
			},
			320: {
				slidesPerView: 2,
				spaceBetween: 8,
			},
		},
		scrollbar: {
			el: ".home-6 .swiper-scrollbar",
			draggable: true,
		},
		mousewheel: {
			forceToAxis: true,
			thresholdTime: 1200,
		},
	});
	var home_6_main = new Swiper(".home-6 .main .swiper", {
		spaceBetween: 10,
		grabCursor: true,
		// autoplay: {
		// 	delay: 3000,
		// },
		navigation: {
			nextEl: ".home-6 .btn-next",
			prevEl: ".home-6 .btn-prev",
		},
		thumbs: {
			swiper: home_6_thumb,
		},
	});
	let introduce_2_3 = new Swiper(`.introduce-layout-2-3 .swiper`, {
		slidesPerView: 1,
		spaceBetween: 0,
		autoplay: {
			delay: 3000,
		},
		navigation: {
			prevEl: `.introduce-layout-2-3 .btn-button-prev`,
			nextEl: `.introduce-layout-2-3 .swiper-button-next`,
		},
		pagination: {
			el: `.introduce-layout-2-3 .swiper-pagination`,
			clickable: true,
		},
	});
	let introduce_3_1 = new Swiper(`.introduce-layout-3-1 .swiper`, {
		slidesPerView: 1,
		spaceBetween: 12,
		autoplay: {
			delay: 3000,
		},
		navigation: {
			prevEl: `.introduce-layout-3-1 .swiper-button-prev`,
			nextEl: `.introduce-layout-3-1 .swiper-button-next`,
		},
		breakpoints: {
			1280: {
				slidesPerView: 4,
				spaceBetween: 65,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 12,
			},
			320: {
				slidesPerView: 2,
				spaceBetween: 8,
			},
		},
	});
	let introduce_4_1 = new Swiper(`.introduce-layout-4-1 .swiper`, {
		grabCursor: true,
		slidesPerView: "auto",
		loop: true,
		breakpoints: {
			1280: {
				effect: "coverflow",
				coverflowEffect: {
					rotate: 0,
					stretch: 0,
					depth: 0,
					modifier: 1,
					slideShadows: false,
				},
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 10,
			},
			320: {
				slidesPerView: 1.2,
				spaceBetween: 10,
			},
		},
		navigation: {
			prevEl: ".introduce-layout-4-1 .swiper-button-prev",
			nextEl: ".introduce-layout-4-1 .swiper-button-next",
		},
	});
	let introduce_4_3 = new Swiper(`.introduce-layout-4-3 .swiper`, {
		speed: 500,
		observer: true,
		observeParents: true,
		breakpoints: {
			1280: {
				spaceBetween: 30,
				slidesPerView: 2,
				grid: {
					rows: "2",
				},
			},
			1024: {
				spaceBetween: 16,
				slidesPerView: 4,
				grid: {
					// fill: "row",
					rows: "2",
				},
			},
			768: {
				spaceBetween: 12,
				slidesPerView: 3,
				grid: {
					// fill: "row",
					rows: "2",
				},
			},
			576: {
				spaceBetween: 12,
				slidesPerView: 2,
				grid: {
					// fill: "row",
					rows: "2",
				},
			},
			320: {
				spaceBetween: 12,
				slidesPerView: 2,
				grid: {
					// fill: "row",
					rows: "2",
				},
			},
		},
		navigation: {
			prevEl: ".introduce-layout-4-3 .swiper-button-prev",
			nextEl: ".introduce-layout-4-3 .swiper-button-next",
		},
	});
	$(".swiper-xl-4").each(function (e) {
		$(this).addClass(`swiper-xl-4-id-${e}`);
		var swiper_xl_4 = new Swiper(`.swiper-xl-4-id-${e} .swiper`, {
			speed: 500,
			observer: true,
			observeParents: true,
			breakpoints: {
				1280: {
					spaceBetween: 32,
					slidesPerView: 4,
				},
				1024: {
					spaceBetween: 24,
					slidesPerView: 3,
				},
				576: {
					spaceBetween: 16,
					slidesPerView: 2,
				},
				320: {
					spaceBetween: 16,
					slidesPerView: 1.3,
				},
			},
			navigation: {
				prevEl: `.swiper-xl-4-id-${e} .swiper-button-prev`,
				nextEl: `.swiper-xl-4-id-${e} .swiper-button-next`,
			},
		});
	});
	var workPlace_tab_1 = new Swiper(".workplace-tab-1 .swiper", {
		autoplay: {
			delay: 3000,
		},
		watchSlidesProgress: true,
		grabCursor: true,
		breakpoints: {
			1230: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			320: {
				slidesPerView: 1.2,
				spaceBetween: 20,
			},
		},
		navigation: {
			prevEl: ".workplace-tab-1 .swiper-button-prev",
			nextEl: ".workplace-tab-1 .swiper-button-next",
		},
	});
	var workPlace_tab_2 = new Swiper(".workplace-tab-2 .swiper", {
		speed: 500,
		observer: true,
		observeParents: true,
		breakpoints: {
			1280: {
				spaceBetween: 30,
				slidesPerView: 3,
				grid: {
					rows: "2",
				},
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 20,
			},
			320: {
				slidesPerView: 1.2,
				spaceBetween: 20,
			},
		},
		navigation: {
			prevEl: ".workplace-tab-2 .swiper-button-prev",
			nextEl: ".workplace-tab-2 .swiper-button-next",
		},
	});
	var projectThumb = new Swiper(".project-image-main .img-thum .swiper", {
		spaceBetween: 10,
		slidesPerView: 2,
		freeMode: true,
		autoplay: {
			delay: 3000,
		},
		watchSlidesProgress: true,
		grabCursor: true,
		breakpoints: {
			768: {
				slidesPerView: 3,
				spaceBetween: 20,
			},
			1230: {
				slidesPerView: 5,
				spaceBetween: 20,
			},
		},
	});
	var projectMain = new Swiper(".project-image-main .img-big .swiper", {
		spaceBetween: 10,
		grabCursor: true,
		autoplay: {
			delay: 3000,
		},
		navigation: {
			nextEl: ".project-image-main .btn-next",
			prevEl: ".project-image-main .btn-prev",
		},
		thumbs: {
			swiper: projectThumb,
		},
	});
	var otherProject = new Swiper(".project-other-main .swiper", {
		spaceBetween: 30,
		slidesPerView: 1,
		autoplay: {
			delay: 3000,
		},
		grabCursor: true,
		navigation: {
			nextEl: ".project-other-main .btn-next",
			prevEl: ".project-other-main .btn-prev",
		},
		breakpoints: {
			1024: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
		},
	});
	setTimeout(() => {
		let heightAboutPersonel = $(
			".page-about-personnel .swiper"
		).outerHeight();
		$(".page-about-personnel .wrap-slide-main").css(
			"height",
			heightAboutPersonel
		);
	}, 1000);

	$(".about-power .item-about-power").each(function (index) {
		let name = `item-number-${index}`;
		$(this).addClass(name);
		new Swiper(`.about-power .${name} .swiper`, {
			slidesPerView: 1,
			autoplay: {
				delay: 3000,
			},
			grabCursor: true,
			navigation: {
				nextEl: `.about-power .${name} .btn-next`,
				prevEl: `.about-power .${name} .btn-prev`,
			},
		});
	});
	var SystemManager1 = new Swiper(".page-system-manager.section-1 .swiper", {
		spaceBetween: 30,
		slidesPerView: 1,
		grabCursor: true,
		autoplay: {
			delay: 3000,
		},
		navigation: {
			nextEl: ".page-system-manager.section-1 .btn-next",
			prevEl: ".page-system-manager.section-1 .btn-prev",
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1280: {
				slidesPerView: 4,
				spaceBetween: 30,
			},
		},
	});
	var SystemManager2 = new Swiper(".page-system-manager.section-3 .swiper", {
		spaceBetween: 30,
		slidesPerView: 1,
		grabCursor: true,
		autoplay: {
			delay: 3000,
		},
		navigation: {
			nextEl: ".page-system-manager.section-3 .btn-next",
			prevEl: ".page-system-manager.section-3 .btn-prev",
		},
	});
	var SystemManager1 = new Swiper(".page-about-rate .swiper", {
		spaceBetween: 30,
		slidesPerView: 1,
		autoplay: {
			delay: 3000,
		},
		grabCursor: true,
		navigation: {
			nextEl: ".page-about-rate .btn-next",
			prevEl: ".page-about-rate .btn-prev",
		},
		pagination: {
			el: ".page-about-rate .swiper-pagination",
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			1024: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1280: {
				slidesPerView: 4,
				spaceBetween: 30,
			},
		},
	});
	// **** Footer ***** //
	var footer_partner = new Swiper("footer .swiper", {
		spaceBetween: 30,
		slidesPerView: 1,
		grabCursor: true,
		autoplay: {
			delay: 3000,
		},
		navigation: {
			prevEl: "footer .swiper-button-prev",
			nextEl: "footer .swiper-button-next",
		},
		breakpoints: {
			1280: {
				slidesPerView: 5,
				spaceBetween: 30,
			},
			1024: {
				slidesPerView: 4,
				spaceBetween: 20,
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 16,
			},
			576: {
				slidesPerView: 3,
				spaceBetween: 12,
			},
			320: {
				slidesPerView: 3.2,
				spaceBetween: 12,
			},
		},
	});
}

function recruitmentDetail() {
	$("html").attr("lang", "vi") ? $(".dialogpage").attr("lang", "vi") : null;
	$("html").attr("lang", "en") ? $(".dialogpage").attr("lang", "en") : null;
}

$(document).on("scroll", function () {
	header.scrollActive();
});
/*==================== Play video ====================*/

function showContent() {
	$(".wrap-show-content").each(function () {
		var computedHeight = $(this).find(".description").css("max-height");
		computedHeight = computedHeight.split("px")[0];
		var realHeight = $(this).find(".description")[0].scrollHeight;
		if (realHeight >= computedHeight) {
			console.log(true);
			$(this).addClass("hide-content");
			$(this)
				.find(".btn-expand-ctn")
				.on("click", function () {
					$(this).toggleClass("active");
					$(this)
						.closest(".wrap-show-content")
						.toggleClass("toggle-content");
				});
		} else {
			$(this).find(".btn-expand-ctn").hide();
			$(this).addClass("cannot-expand");
		}
	});
}

function jsScrollSlide() {
	var position = ["left", "right"];
	$(".scroll-slide-show-item").each(function (e) {
		if (e % 2 == 0) {
			var currentPosition = position[e];
		} else {
			var currentPosition = position[e];
		}
		// console.log(currentPosition);

		$(this).jScrollability(
			function ($el) {
				return $el.offset().top;
			},
			function ($el) {
				return $el.offset().top + $el.height() * 5;
			},
			function ($el, pcnt) {
				$el.css({
					[currentPosition]: (1 - pcnt) * 100 - 80 + "%",
				});
			}
		);
	});
}

function expandItem() {
	// Filter Load
	var hasLoadBtn = $("[has-expand-btn]");
	hasLoadBtn.each(function () {
		var $this = $(this);
		var expandBtn = $(this).find(".expand-btn");
		var list = $(this).find(".expand-item").length;
		var count;
		var countMobile = $(this).attr("item-count-mobile");
		countMobile != undefined && countMobile != 0 && ww < 576
			? (count = Number($(this).attr("item-count-mobile")))
			: (count = Number($(this).attr("item-count")));
		var expand = Number($(this).attr("item-expand"));
		function init(initValue, thisFunction) {
			thisFunction
				.find(".expand-item")
				.slice(0, initValue)
				.slideDown({
					complete: function () {
						setTimeout(() => {
							$(this).addClass("done-animated");
						}, 300);
					},
				});
			if (list == 0 || list <= initValue) {
				expandBtn.hide();
			}
		}
		init(count, $this);

		// Click
		function expandBtnInit(initCount, thisFunction) {
			count = initCount + expand <= list ? initCount + expand : list;
			thisFunction
				.closest(hasLoadBtn)
				.find(".expand-item")
				.slice(0, count)
				.slideDown({
					complete: function () {
						setTimeout(() => {
							$(this).addClass("done-animated");
						}, 300);
					},
				});
			// console.log(count);
			if (count == list) {
				thisFunction.slideUp();
			}
		}
		expandBtn.on("click", function (e) {
			e.preventDefault();
			expandBtnInit(count, $(this));
		});
	});
}
